<template>
  <div>
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="515px"
      :show-close="!isSaving"
      style="margin: 0 auto;"
      :visible.sync="isShow"
      @close="
        referred_by_tags = [];
        referralInput = '';
        typeUrlCheck = false;
        urlValue = '';
        handleCancel();
      "
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="InvestmentSave">
        <div class="row">
          <div class="col-6">
            <div>
              Investment Type
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.investment_type"
              :disabled="checkTypeDisabled"
              size="large"
              placeholder="Investment Type"
            >
              <el-option
                v-for="item in vals.INVESTMENT_TYPE"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="col-6">
            <div>
              Round
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.offering"
              size="large"
              placeholder="Round"
            >
              <el-option
                v-for="item in vals.INVESTMENT_OFFERINGS"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="row">
          <div class="col-6" v-if="showAmount">
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Exercise Price ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.excerise_price"
              placeholder="Exercise Price ($)"
              min="0"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>Price per share ($)</div>
            <b-input
              class="form-control team-form"
              style="width: 100%"
              @keypress="onlyForCurrency"
              @keyup="calculateAmount"
              v-model="value.data.price_per_share"
              placeholder="Price per share ($)"
              min="0"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Proceeds'"
          >
            <div>Investment Proceeds Type</div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.investment_proceeds_type"
              size="large"
              placeholder="Type"
            >
              <el-option
                v-for="item in vals.INVESTMENT_PROCEEDS_TYPE"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-6">
            <div>Investment Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              type="date"
              :value="
                value.data.transaction_date &&
                  moment.utc(value.data.transaction_date).format('YYYY-MM-DD')
              "
              @input="
                value.data.transaction_date = moment($event.target.valueAsDate)
              "
              placeholder="Current Cost"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-if="showCap">
            <div>Cap ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.cap"
              placeholder="Cap ($)"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Terms(years)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.term_years"
              placeholder="Terms(years)"
              min="0"
              step=".1"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>No. of shares (#)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              @keyup="calculateAmount"
              v-model="value.data.no_of_shares"
              placeholder="No. of shares (#)"
              min="0"
              step="any"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Proceeds'"
          >
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.proceeds_amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
          <div class="col-6" v-if="showDiscount">
            <div>Discount (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.discount"
              placeholder="Discount (%)"
              min="0"
              max="100"
              step=".01"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Coverage (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.coverage"
              placeholder="Coverage (%)"
              min="0"
              max="100"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Bridge Loan'"
          >
            <div>Interest (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.interest_rate"
              placeholder="Interest (%)"
              min="0"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              @keyup="calculateShareCount"

              v-model="value.data.amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-if="showEquityStanding">
            <div>Equity (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.equity_standing"
              placeholder="Equity (%)"
              min="0"
              max="100"
              step=".01"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Convertible Note'"
          >
            <div>Interest (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.interest"
              placeholder="Interest (%)"
              min="0"
              max="100"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Maturity Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              type="date"
              :value="
                value.data.maturity_date &&
                  moment(value.data.maturity_date).format('YYYY-MM-DD')
              "
              @input="
                value.data.maturity_date = moment($event.target.valueAsDate)
              "
              placeholder="Maturity Date"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Bridge Loan'"
          >
            <div>Due Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              min="2000-01-01"
              type="date"
              :value="
                value.data.due_date &&
                  moment(value.data.due_date).format('YYYY-MM-DD')
              "
              @input="value.data.due_date = moment($event.target.valueAsDate)"
              placeholder="Maturity Date"
            />
          </div>
          <div class="col-6">
            <div>Current Value</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.currentValue"
              placeholder="Value"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row" v-if="value.data.investment_type == 'Warrant'">
          <div class="col-12">
            <div>Security</div>
            <input
              type="text"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.security"
              placeholder="Security"
              min="0"
            />
          </div>
        </div>
        <div class="row" style="margin-bottom: 6px">
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.is_prorata"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                :disabled="isIPOAcquisitionStatus()"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Pro Rata Rights</span>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.information_rights"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                :disabled="isIPOAcquisitionStatus()"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Information Rights</span>
            </div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 6px">
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.is_lead_investor"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Lead Investor</span>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.board_seat"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Board Seat</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div>Notes</div>
            <textarea
              placeholder="Notes"
              rows="5"
              cols="50"
              class="form-control"
              spellcheck="false"
              v-model="value.data.notes"
            ></textarea>
          </div>
        </div>
        <div style="padding-bottom: 3px">Attachments</div>
        <div class="row m-0">
          <div
            class="col-4 attach-class"
            id="popover-target-2"
            style="padding-top: 6px"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            Attach a file
            <input
              type="file"
              ref="fileBtn"
              if="fileId"
              @change="handleFile"
              class="hidden"
            />
          </div>
          <b-popover
            target="popover-target-2"
            triggers="hover"
            placement="top"
            custom-class="popover-modal-class"
          >
            <div
              class="m-2"
              style="cursor: pointer"
              @click="
                $refs.fileBtn.click();
                typeUrlCheck = false;
              "
            >
              From Computer
            </div>
            <div
              class="m-2"
              style="cursor: pointer"
              @click="typeUrlCheck = !typeUrlCheck"
            >
              Add Link
            </div>
          </b-popover>
          <div
            class="col-8 drag-drop-class"
            style="padding-top: 6px"
            v-if="!typeUrlCheck"
            v-cloak
            @drop.prevent="addFile"
            @dragover.prevent
          >
            Drag and drop file to attach
          </div>
          <div class="col-8" style="padding: 0" v-else>
            <form @submit.prevent="submitUrl">
              <input
                type="text"
                class="form-control team-form url-input-form"
                placeholder="Add a URL"
                id="myInput"
                @blur="submitUrl"
                v-model="urlValue"
                @
              />
            </form>
          </div>
        </div>
        <div class="mt-3">
          <div v-if="url.add">
            <div
              v-for="(item, index) in url.add"
              :key="index"
              class="fileItem my-2"
            >
              <a :href="formatUrl(item)" target="_blank">
                <span class="attachment-name-class">{{ item }}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index, 'add')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="url.update">
            <div
              v-for="(item, index) in url.update"
              :key="index"
              class="fileItem my-2"
            >
              <a :href="formatUrl(item.url)" target="_blank">
                <span class="attachment-name-class">{{ item.url }}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index, 'update')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="files.add">
            <div
              v-for="(item, index) in files.add"
              :key="index"
              class="d-flex fileItem my-2"
            >
              <i
                v-if="
                  item.type.includes('.doc') ||
                    item.name.includes('.doc') ||
                    item.name.includes('.txt')
                "
                class="fas fa-file-word mr-2 mt-1"
                style="color: #5190ff"
              ></i>
              <i
                v-else-if="
                  item.type.includes('zip') ||
                    item.name.includes('.zip') ||
                    item.type.includes('rar') ||
                    item.name.includes('.rar')
                "
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i
                v-else-if="item.type.includes('image')"
                class="fas fa-image mr-2"
              ></i>
              <i
                v-else-if="
                  item.type.includes('csv') ||
                    item.type.includes('xls') ||
                    item.name.includes('.csv') ||
                    item.name.includes('.xls')
                "
                class="fas fa-file-excel mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <i
                v-else-if="
                  item.type.includes('pdf') || item.type.includes('.pdf')
                "
                class="fas fa-file-pdf mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item, 'file')"
                style="cursor: pointer"
                >{{ item.name }}</span
              >
              <i
                class="fas fa-times"
                @click="deleteFile(index, 'add')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="files.update">
            <div
              v-for="(item, index) in files.update"
              :key="index"
              class="d-flex fileItem my-2"
            >
              <i
                v-if="item.name.includes('.doc')"
                style="color: #5190ff"
                class="fas fa-file-word mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('zip') || item.name.includes('.rar')
                "
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('.jpg') || item.name.includes('.png')
                "
                class="fas fa-image mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('.csv') || item.name.includes('.xls')
                "
                class="fas fa-file-excel mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <i
                v-else-if="item.name.includes('.pdf')"
                style="color: #f15643"
                class="fas fa-file-pdf mr-2 mt-1"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item, 's3')"
                style="cursor: pointer"
                >{{ item.name }}</span
              >
              <i
                class="fas fa-times"
                @click="deleteFile(index, 'update')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
        </div>

        <!-- previous round accordian -->
        <div
          style="margin-bottom: 20px"
          v-if="value.previous_round && value.previous_round._id"
        >
          <div class="accordian">
            <b-button v-b-toggle.previous-round>
              <p>
                Previous Round
              </p>
              <i class="fas fa-chevron-down"></i>
            </b-button>
          </div>
          <b-collapse id="previous-round">
            <div style="margin-bottom: 15px">Previous Round Details</div>
            <div class="row mb-2">
              <div class="col-6">Round</div>
              <div
                class="col-6 previousValue"
                v-if="value.previous_round.offering"
              >
                {{ value.previous_round.offering }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Date</div>
              <div class="col-6 previousValue" v-if="value.previous_round.date">
                {{ moment(value.previous_round.date).format("MM/DD/YYYY") }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Pre $</div>
              <div
                class="col-6 previousValue"
                v-if="value.previous_round.preMoney"
              >
                {{ value.previous_round.preMoney }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Round Size</div>
              <div
                class="col-6 previousValue"
                v-if="value.previous_round.roundSize"
              >
                {{ value.previous_round.roundSize }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Post $</div>
              <div
                class="col-6 previousValue"
                v-if="value.previous_round.postMoney"
              >
                {{ value.previous_round.postMoney }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">PPS $</div>
              <div
                class="col-6 previousValue"
                v-if="value.previous_round.pricePerShare"
              >
                {{ value.previous_round.pricePerShare }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Verified</div>
              <div class="col-6 previousValue">
                {{ value.previous_round.isVerified ? "Yes" : "No" }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Lead Investor</div>
              <div class="col-6 previousValue">
                {{
                  value.previous_round.leadInvestor
                    ? value.previous_round.leadInvestor
                    : "-"
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">Did you Participate?</div>
              <div class="col-6 previousValue">
                {{ value.previous_round.isParticipated ? "Yes" : "No" }}
              </div>
            </div>
            <!-- <div class="row mb-2">
             <div class="col-6">Participated</div>
             <div class="col-6 previousValue">{{value.previous_round.isParticipated ?"Yes":"No"}}</div>
           </div>-->
          </b-collapse>
        </div>

        <!-- add round accordian -->
        <div class="accordian">
          <b-button v-b-toggle.add-round>
            <p>
              Round
            </p>
            <i class="fas fa-chevron-down"></i>
          </b-button>
        </div>
        <b-collapse visible appear id="add-round">
          <div
            style="margin-bottom: 15px"
            v-if="value.previous_round && value.previous_round._id"
          >
            {{ value.isCreate ? "Add New Round" : "Edit Round" }}
          </div>
          <div class="row">
            <div class="col-6">
              <div>Round</div>
              <el-select
                class="todo-dropdown-el-select"
                v-model="value.data.offering"
                size="large"
                placeholder="Round"
              >
                <el-option
                  v-for="item in vals.INVESTMENT_OFFERINGS"
                  :value="item"
                  :label="item"
                  :key="item"
                ></el-option>
              </el-select>
            </div>
            <div class="col-6">
              <div>Date</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                :value="
                  value.data.date &&
                  moment.utc(value.data.date).format('YYYY-MM-DD')
                    ? moment.utc(value.data.date).format('YYYY-MM-DD')
                    : moment.utc(new Date()).format('YYYY-MM-DD')
                "
                @input="value.data.date = moment($event.target.valueAsDate)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Pre $</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Pre $"
                v-model="value.data.preMoney"
              />
            </div>
            <div class="col-6">
              <div>Post $</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Post $"
                v-model="value.data.postMoney"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <div>Price Per Share</div>
              <input
                class="form-control"
                @keypress="onlyForCurrency"
                placeholder="Price Per Share"
                v-model="value.data.pricePerShare"
              />
            </div>
            <div class="col-6">
              <div>Lead Investor</div>
              <input
                type="text"
                class="form-control"
                placeholder="Lead Investor"
                v-model="value.data.leadInvestor"
              />
            </div>
          </div>
          <div class="row" style="margin-right: 5px">
            <div class="col-6">
              <div class="d-flex">
                <div style="margin-top: auto; margin-bottom: auto">
                  Verified
                </div>
                <label class="switchValuationToggle">
                  <input
                    type="checkbox"
                    id="togBtn"
                    v-model="value.data.isVerified"
                  />
                  <div class="sliderValuationToggle round"></div>
                </label>
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex">
                <div style="margin-top: auto; margin-bottom: auto">
                  Did you Participate?
                </div>
                <label class="switchValuationToggle">
                  <input
                    type="checkbox"
                    id="togBtn"
                    v-model="value.data.isParticipated"
                  />
                  <div class="sliderValuationToggle round"></div>
                </label>
              </div>
            </div>
            <!-- <div class="col-6">
               <div class="d-flex">
                 <div style="margin-top:auto;margin-bottom:auto">Participated</div>
                 <label class="switchValuationToggle">
                   <input type="checkbox" id="togBtn" v-model="value.data.isParticipated" />
                   <div class="sliderValuationToggle round"></div>
                 </label>
               </div>
             </div>-->
          </div>
        </b-collapse>

        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            :disabled="isSaving"
            @click="handleCancel()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="
              ((value.data &&
                value.data.offering &&
                value.data.offering.length > 0) ||
                value.previous_round) &&
              !isSaving
                ? false
                : true
            "
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="isSaving"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <el-dialog
      center
      width="702px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="investmentSubmit"
    >
      <div class="container">
        <div class="d-flex justify-content-center">
          <img src="static/img/validateEquityStanding.svg" />
        </div>
        <div class="d-flex justify-content-center" style="margin-top: 30px">
          <div class="validateEquityTitle">Saved Successfully</div>
        </div>
        <div class="d-flex justify-content-center" style="margin-top: 15px">
          <div class="validateEquityModalText">
            Would you like us to help you validate your Standing in the company?
          </div>
        </div>
        <div class="d-flex justify-content-center" style="margin-top: 15px">
          <div class="validateEquityModalText">
            We can help you by reaching out to the founders and verifying your
            investment status. Don't worry, you will be able to edit the email
            before sending.
          </div>
        </div>
        <div class="col-12 d-flex" style="padding: 0px; margin-top: 30px">
          <div
            class="col-xl edit-company-action-button-row"
            style="padding: 0px"
          >
            <button
              type="button"
              @click.prevent="createTodo"
              class="nextBtn"
              style="height: 35px; width: auto"
            >
              Save as To-do
            </button>
            <a :href="emailString" v-if="emailString" target="_blank">
              <button
                type="button"
                class="ml-2 todo-form-submit-button btn btn-primary"
                @click="investmentSubmit = !investmentSubmit"
              >
                Verify Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      width="580px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="showFounderEmailConfirm"
      @close="handleCancelContact()"
    >
      <div class="container" v-if="!showPreviewMessage">
        <div>
          <div
            class="d-flex justify-content-center"
            style="margin-bottom: 30px"
          >
            <img src="static/img/validateEquityStanding.svg" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 no_word_break" v-if="contactEmail">
            One of the ways we help investors is by making KPI requests for you.
            This makes both you and your investments life easier, less
            intrusive, and much more efficient.

            <br />
            <br />
            Would you like us to collect KPI’s from your investment?
            <br />
            <br />

            As per the company information we have, the company email address is
            {{ contactEmail }}. Please confirm whether it is correct or not.
          </div>
          <div class="col-12 no_word_break" v-if="!contactEmail">
            One of the ways we help investors is by making KPI requests for you.
            This makes both you and your investments life easier, less
            intrusive, and much more efficient.

            <br />
            <br />
            Would you like us to collect KPI’s from your investment?
            <br />
            <br />

            Currently we don't have the contact email of the company. Please
            enter the contact email of the company.
          </div>

          <div class="col-12" v-if="contactEmail">
            <div class="radio-wrapper">
              <l-radio
                v-bind:groupname="'correctEmail'"
                v-model="isCorrectCompanyEmail"
                value="Yes"
                label="Yes"
                >Yes</l-radio
              >
              <l-radio
                v-bind:groupname="'correctEmail'"
                v-model="isCorrectCompanyEmail"
                value="No"
                label="No"
                >No</l-radio
              >
            </div>
          </div>

          <div
            class="col-12"
            style="margin-top: 20px"
            v-if="isCorrectCompanyEmail == 'No' || !contactEmail"
          >
            <div>Enter email address</div>
            <input
              type="email"
              class="form-control team-form"
              style="width: 294px"
              v-model="newContactEmail"
              placeholder="Eg. founder@company.com"
            />
          </div>

          <div class="col-12 text-right">
            <button
              class="todo-form-cancel-button btn-outline-secondary"
              style="margin-right: 10px"
              @click="displayPreviewMessage(true)"
            >
              Preview
            </button>
            <button
              class="todo-form-submit-button"
              @click="saveContactEmail()"
              style="height: 35px"
            >
              Save
              <b-spinner
                v-if="savingContact"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </div>
      </div>
      <div v-if="showPreviewMessage">
        <div class="col-12 text-right">
          <div class="email-preview-header">
            <div class="workspace-logo">fiifi</div>
          </div>
          <div class="email-preview">
            <p>
              Hi, my name is Theron McCollough the founder and CEO of fiifi.co,
              the tool making information sharing with your investors really
              easy, and totally free.
            </p>
            <p>
              {{workspaceOwner}} has stated they would like KPI updates from you. We
              have also found a list of your existing investors, do you want
              them to receive the updates also?
            </p>
            <!-- button -->
            <button>
              Investor List
            </button>
            <p>
              You will receive an email from us on the 25th of every month.
              Reply to the same email with your current KPI’s and we take care
              of the rest.
            </p>
            <p>
              You are in total control of who receives your info, and can manage
              your investors through the link above.
            </p>
            <p>
              Thank you,
            </p>
            <p>
              Founders
            </p>
            <p>
              If you do not approve this investor to get KPI updates you can
              ignore this email or click on the link above to manage investor
              access.
            </p>
          </div>
          <button
            class="todo-form-cancel-button btn-outline-secondary"
            style="margin-right: 10px"
            @click="displayPreviewMessage(false)"
          >
            Go Back
          </button>
          <button
            class="todo-form-submit-button"
            @click="saveContactEmail()"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="savingContact"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>

    <a class="hidden" ref="hiddenDownloadAnchor" :href="downloadLink"
      >Download Sample</a
    >
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize } from "../../../util";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import TagsInput from "@voerro/vue-tagsinput";
import { Radio } from "src/components/index";

import { Company, patchCompany } from "../../../models/Company";

import router from "../../../main";
import offering from "../../../store/modules/offering";

export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    TagsInput
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      previous_round: Object
    },
    workspaceOwner: String,
    organization: "",
    investmentData: Object,
    contactEmail: String,
    lastFundingRoundDate: String,
    currentCompany: Object,
    context: String,
    investments: Array,
    default: () => {
      return [];
    }
  },
  computed: {
    // getCurrentValue(){
    //   // if(this.value.investment_type==="Equity"){
    //   if(this.value.data.currentValue){
    //     return this.value.data.currentValue
    //   }else{
    //     return this.value.data.amount
    //   }
    //   // }
    //   // else{
    //   //   return this.value.data.currentValue
    //   // }
    // },
    moment() {
      return moment;
    },
    showAmount() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note" ||
        this.value.data.investment_type == "Bridge Loan" ||
        this.value.data.investment_type == "Unknown"
      )
        return (display = true);
    },
    showDiscount() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note"
      )
        return (display = true);
    },
    showEquityStanding() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Equity" ||
        this.value.data.investment_type == "Proceeds" ||
        this.value.data.investment_type == "Unknown"
      )
        return (display = true);
    },
    showCap() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note" ||
        this.value.data.investment_type == "Bridge Loan"
      )
        return (display = true);
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      }
    },
    title: {
      get() {
        if (this.value.isCreate) {
          return "Add Your Investment";
        } else if (this.value.isEdit) {
          return "Edit Your Investment";
        } else if (this.value.isConvertToEquity) {
          return "Convert To Equity";
        }
        // return this.value.isCreate
        //   ? "Add Your Investment"
        //   : "Edit Your Investment";
      }
    }
  },
  watch: {
    isShow: function(val) {
      if (val) {
        this.setUploadedFiles();
        this.checkInvestmentType();
        // this.setReferredBy();
      }
    }
    // referred_by_tags: function(data) {
    //   if (this.$refs.tagsRef.clearInput()) {
    //     this.$refs.tagsRef.clearInput();
    //   }
    //   this.referralInput = "";
    // }
  },
  data() {
    return {
      showPreviewMessage: false,
      vals,
      isSaving: false,
      downloadLink: "",
      existingRefers: [],
      addTagsOnBlur: true,
      caseSensitiveTags: false,
      investmentSubmit: false,
      emailString: "",
      typeMaxResults: 5,
      company_name: "",
      referred_by_tags: [],
      checkTypeDisabled: false,
      referralInput: "",
      files: {
        add: [],
        update: [],
        delete: []
      },
      urlValue: "",
      typeUrlCheck: false,
      deletedReferrals: [],
      url: {
        add: [],
        update: [],
        delete: []
      },
      currentValue: 0,
      valueCheck: false,
      handleCostCheck: false,

      showFounderEmailConfirm: false,
      companyEmail: "",
      isCorrectCompanyEmail: "Yes",
      newContactEmail: "",
      savingContact: false,
      isSavingClicked: false
    };
  },
  mounted() {
    //this.currentValue = this.currentCompany.value;
    if (this.value.previous_round) {
      this.value.data.offering = this.value.previous_round.offering;
    }
    if (!this.contactEmail) {
      this.isCorrectCompanyEmail = "No";
    }
  },
  methods: {
    checkIfValidEmail() {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (!reg.test(this.newContactEmail) && this.newContactEmail.length > 0) {
        // console.log(reg.test(this.newContactEmail));
        // console.log(reg.test(this.contactEmail));
        this.$toaster.error("Invalid Email Address");
        return false;
      }

      return true;
    },
    displayPreviewMessage(display) {
      if (this.checkIfValidEmail()) {
        this.showPreviewMessage = display;
      }
    },
  
    calculateAmount() {
      let total = 0;

      if (this.value.data.no_of_shares && this.value.data.price_per_share) {
        total = this.value.data.no_of_shares * this.value.data.price_per_share;
      }

      this.value.data.amount = total;
      if(this.value.data.investment_type==="Equity"){
      this.value.data.currentValue = total; 
      }
      

      this.$forceUpdate();
    },
    calculateShareCount() {
      let total = 0;
      if (this.value.data.amount && this.value.data.price_per_share) {
        total = this.value.data.amount / this.value.data.price_per_share;
      }
      if(this.value.data.investment_type==="Equity"){
      this.value.data.currentValue = this.value.data.amount; 
      }
      this.value.data.no_of_shares = total;

      this.$forceUpdate();
    },
    defaultDynamicValues() {
      if (this.value.isCreate) {
        this.value.data.amount = this.value.data.cap = this.value.data.dicount = this.value.data.equity_standing =
          "";
        this.value.data.interest = this.value.data.interest_rate = this.value.data.excerise_price = this.value.data.term_years =
          "";
        this.value.data.maturity_date = this.value.data.due_date = "";
        this.value.data.no_of_shares = this.value.data.price_per_share = "";
      }
    },
    checkInvestmentType() {
      this.checkTypeDisabled = false;
      if (
        !this.value.isCreate &&
        this.value.data.investment_type.includes("Proceeds")
      ) {
        this.checkTypeDisabled = true;
      }
    },
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    handleCancel() {
      this.value.isShow = false;
      this.isSaving = false;
      this.files = {
        add: [],
        update: [],
        delete: []
      };
      this.url = {
        add: [],
        update: [],
        delete: []
      };
      this.urlValue = "";
      this.typeUrlCheck = false;
    },
    submitUrl() {
      this.urlValue = this.urlValue.trim();
      if (this.urlValue.length > 0) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.typeUrlCheck = false;
    },
    setReferredBy() {
      if (this.value.data && this.value.data.referred_by)
        this.referred_by_tags = this.value.data.referred_by;
    },
    onBlur() {
      self.setTimeout(() => {
        if (this.referralInput) {
          let tag = { key: "", value: this.referralInput };
          if (this.referred_by_tags && this.referred_by_tags.length > 0)
            this.referred_by_tags.push(tag);
          else this.referred_by_tags = [tag];
          this.$refs.tagsRef.clearInput();
        }
      }, 500);
    },
    createTodo() {
      let data = {};
      data.status = "New";
      data.is_quick_task = false;
      data.task_type = "todo";
      data.urgency = 9;
      data.component = "portfolio";
      data.assigned_to = [this.$route.params.account_id];
      data.priority = "medium";
      data.workspace = this.$route.params.workspace_id;
      data.due_date = moment
        .utc(new Date().setDate(new Date().getDate() + 7))
        .format("YYYY-MM-DD");
      data.action_type = "Email";
      data.description = `Send Equity Standing email to ${this.company_name}`;
      data.title = `Verify Equity Standing in ${this.company_name}`;
      api
        .post("/todo", {
          encrypt: {
            data: {
              todo: data
            }
          }
        })
        .then(resp => {
          this.$toaster.success("Saved successfully.");
          //this.$store.commit("todo/setTodoData", resp.data.encrypt.success[0]);
          this.$store.getters["todo/componentTodos"](
            "portfolio",
            this.$route.params.workspace_id
          );
          this.investmentSubmit = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    tagRemoved(e) {
      if (!this.value.isCreate)
        this.deletedReferrals.push({ key: 0, value: e.value });
    },
    async setUploadedFiles() {
      this.files = { add: [], delete: [], update: [] };
      let uploadedDocs = [];
      if (!this.value.isCreate && this.value.data._id) {
        uploadedDocs = await this.$store.getters["file/filesByInvestmentId"](
          this.value.data._id
        );
      }

      if (uploadedDocs.length) {
        uploadedDocs.map(item => {
          if (item.link_type == "File") this.files.update.push(item);
          else this.url.update.push(item);
        });
      }
    },
    deleteURL(index, type) {
      if (type == "add") this.url.add.splice(index, 1);
      else {
        let data = this.url.update.splice(index, 1);
        this.url.delete.push(data[0]);
      }
    },
    onChange(value) {
      let self = this;
      self.referralInput = value;
      api
        .get(`/attributors/${self.$route.params.workspace_id}/${value}`)
        .then(data => {
          self.existingRefers = [];
          data.data.encrypt.data.map(item => {
            let json = {};
            json.key = item._id;
            json.value = item.name.charAt(0).toUpperCase() + item.name.slice(1);
            self.existingRefers.push(json);
          });
        })
        .catch(err => {
          console.log("error", err);
        });
    },
    deleteFile(index, type) {
      if (type == "add") this.files.add.splice(index, 1);
      else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.add.push(f);
      });
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.add.push(f);
      });
    },
    InvestmentSave() {
      let self = this;
      let offeringChanged = false;
      if (this.value.previous_round && !this.value.data.offering) {
        this.value.data.offering = this.value.previous_round.offering;
        offeringChanged = true;
      }
      if (!this.value.data.offering) {
        this.$toaster.error("Missing required Parameter:Offering");
        return;
      }

      // check if `Information Rights` is checked and this is the first investment.
      // if (this.value.data.information_rights === "true" && !this.investments.length) {
      if (!this.investments.length) {
        this.showFounderEmailConfirm = true;
      } else {
        self.saveInvestment(offeringChanged);
        // if(!offeringChanged){
        //   console.log("investment save if ");
        //   self.saveRound();
        // }
      }
    },
    saveInvestment(offeringChanged = false) {
      let self = this;
      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      let currentCompany = JSON.parse(JSON.stringify(self.currentCompany));

      this.isSaving = true;
      if (this.value.data.notes == undefined) {
        delete this.value.data.notes;
        delete this.value.data.noteId;
      }
      if (this.referred_by_tags)
        this.value.data.referred_by = this.referred_by_tags;
      if (this.value.isCreate) {
        self.company_name = this.value.data.company_name || "";

        self.value.data.transaction_date = self.value.data.transaction_date
          ? self.value.data.transaction_date
          : new Date();

        try {
          const x = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
          self.value.data.transaction_date = x.local(); //.format("MM/DD/YYYY");
        } catch (e) {}

        this.$store
          .dispatch("investment/createInvestment", this.value.data)
          .then(inserteddata => {
            if (!this.investments.length) {
              let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/investment-mail`;

              console.log("sending email to: ", self.contactEmail);
              api
                .post(url, {
                  encrypt: {
                    data: {
                      emails: [self.contactEmail],
                      subject: "Fiifi | KPI Update",
                      portfolio_item: self.value.data.portfolio_item,
                      account: router.currentRoute.params.account_id,
                      companyName: self.company_name
                    }
                  }
                })
                .then(() => {});
            }

            if (
              self.$parent &&
              self.$parent.$refs.noteRef &&
              self.$parent.$refs.noteRef
            )
              self.$parent.$refs.noteRef.getNotes();
            if (self.context == "company-profile") {
              self.handleCost();
            }
            let serverData = {};
            if (
              !self.valueCheck &&
              self.currentCompany.value != self.value.data.currentValue
            ) {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
              serverData.value = self.value.data.currentValue;
            } else {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
            }

            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              // console.log("response : ", response);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  if (self.$parent && self.$parent.tabulator) {
                    let data = self.$store.getters["portfolio/portfolioData"];
                    self.$parent.tabulator.updateData(data);
                  }
                  if (
                    self.currentCompany.value != self.value.data.currentValue
                  ) {
                    this.$toaster.success("Current Value Updated");
                  }
                });
            });

            api
              .get(`/portfolio/investments/${self.value.data.portfolio_item}`)
              .then(data => {
                //self.handleCost();
                self.$emit("investment-save", data.data.encrypt.success);
                // if (
                //   data &&
                //   data.data.encrypt.success &&
                //   data.data.encrypt.success.length == 1
                // ) {
                //   self.$emit("sendKpiEmail", data.data.encrypt.success);
                // }
                this.handleCostCheck = false;
                if (self.contactEmail) {
                  let userName = self.$store.getters["user/user"];
                  let userNameString = `${userName.firstName} ${userName.lastName} `;
                  let subject = "Enquiry";
                  let fullyDilutedEquityStanding = self.value.data
                    .equity_standing
                    ? self.value.data.equity_standing
                    : 0;
                  let fullAmount = self.value.data.amount
                    ? self.value.data.amount
                    : 0;
                  let fullyDilutedEquity =
                    Number(currentCompany.ownership) +
                    Number(fullyDilutedEquityStanding);
                  fullyDilutedEquity = fullyDilutedEquity
                    ? fullyDilutedEquity
                    : "";
                  let amountInvested =
                    Number(currentCompany.cost) + Number(fullAmount);
                  amountInvested = amountInvested ? amountInvested : "";
                  let currentData;
                  let updateData =
                    "The current number of shares\nThe company's current valuation";
                  if (
                    fullyDilutedEquity ||
                    amountInvested ||
                    self.lastFundingRoundDate
                  ) {
                    currentData = `I currently show that:\n\n`;
                    if (fullyDilutedEquity) {
                      currentData += `Current Fully Diluted Equity: ${fullyDilutedEquity}%\n`;
                    } else {
                      updateData += "\nMy current fully diluted equity";
                    }
                    if (amountInvested) {
                      currentData += `Current Amount Invested: $${amountInvested} USD\n`;
                    } else {
                      updateData += "\nMy current amount invested";
                    }
                    if (self.lastFundingRoundDate) {
                      currentData += `Date of last round of Funding: ${self.lastFundingRoundDate}`;
                    } else {
                      updateData += "\nThe date of your last round of funding";
                    }
                    currentData += `\n\nPlease correct any of the data above and update me to the below, if possible.\n\n`;
                  } else {
                    currentData =
                      "\n\nPlease update me to the below, if possible.\n\n";
                    updateData +=
                      "\nMy current fully diluted equity\nMy current amount invested\nThe date of your last round of funding";
                  }
                  // let body = `Hi,\nI’m updating my files and was hoping to get my current standing with my investment in ${
                  //   self.company_name
                  // }.\n\n${currentData ||
                  //   ""} Please update the details below.\n\nMy current fully diluted equity\nThe current number of shares, if applicable.\nThe company's current valuation\nThe date of your last round of funding.\n\n Sincerely,\n${userNameString}`;
                  let body = `Hi we are reaching out on behalf of ${userNameString} to validate a bit of information.\n\nfiifi will only send emails when you have closed a new round of funding or something major has happened. This is great to keep my files up to speed and to be the most helpful to you.\n\nWould you be willing to share my current investment standing so I can update my files with ${self.company_name}?\n\n${currentData}${updateData}\n\nI will not bother you in the future with this info as you are a new investment I wanted to get this info to start things off.\n\nSincerely,\n${userNameString}`;
                  body = encodeURIComponent(body);
                  self.emailString = `mailto:${self.contactEmail}?subject=${subject}&body=${body}`;
                  // self.investmentSubmit = true;
                }
                self.saveFiles(inserteddata);
                if (offeringChanged) {
                  this.$toaster.success("Saved successfully.");
                  this.isShow = false;
                } else {
                  this.saveRound();
                }
                self.updatePortfolioValue(currentCompany._id);
              })
              .catch(err => {
                console.log(err);
                self.isSaving = false;
              });
          })
          .catch(err => {
            self.isSaving = false;
            console.log({ err });
          });
      } else {
        let updateData = JSON.parse(JSON.stringify(this.value.data));

        try {
          const x = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
          updateData.transaction_date = x.local(); //.format("MM/DD/YYYY");
        } catch (e) {}

        let updateEquityStanding;
        if (
          this.investmentData.hasOwnProperty("equity_standing") &&
          this.investmentData.equity_standing.value
        ) {
          updateEquityStanding = JSON.parse(
            JSON.stringify(this.investmentData.equity_standing)
          );
          updateEquityStanding.value = this.value.data.equity_standing
            ? this.value.data.equity_standing
            : "";
        } else {
          if (this.value.data.equity_standing != "") {
            updateEquityStanding = {
              _id: 0,
              value: this.value.data.equity_standing
            };
          }
        }
        updateData.equity_standing = updateEquityStanding
          ? JSON.parse(JSON.stringify(updateEquityStanding))
          : "";
        if (updateData.equity_standing == "") {
          delete updateData.equity_standing;
        }
        self.$store
          .dispatch("investment/updateInvestment", updateData)
          .then(resp => {
            if (self.$parent && self.$parent.transactionDetails) {
              let data = self.$parent.handleParseData();
              self.$parent.tabulator.updateData(data);
            }
            if (
              self.$parent &&
              self.$parent.$refs.noteRef &&
              self.$parent.$refs.noteRef
            )
              self.$parent.$refs.noteRef.getNotes();
            // if (
            //   self.context == "company-profile" &&
            //   (self.investmentData.amount != self.value.data.amount ||
            //     (self.investments.length > 1 &&
            //       self.value.data.equity_standing != "") ||
            //     self.investments.length == 1)
            // )
            if (
              self.context == "company-profile" &&
              (self.investmentData.amount != self.value.data.amount ||
                (!self.investmentData.equity_standing &&
                  self.value.data.equity_standing != "") ||
                (self.investmentData.equity_standing &&
                  self.investmentData.equity_standing.value !=
                    self.value.data.equity_standing))
            ) {
              self.handleCostCheck = true;
              self.handleCost();
            }
            let index = self.investments.findIndex(item => {
              return item._id == self.value.data._id;
            });
            let serverData = {};
            if (
              (!self.valueCheck &&
                self.currentCompany.value != self.value.data.currentValue) ||
              (index == 0 && !self.handleCostCheck)
            ) {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
              serverData.value = Number(self.value.data.currentValue);
              if (index == 0) {
                serverData.initial_investment = self.value.data.transaction_date
                  ? self.value.data.transaction_date
                  : new Date();
              }
            } else {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
            }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  if (
                    self.currentCompany.value != self.value.data.currentValue
                  ) {
                    this.$toaster.success("Current Value Updated");
                  }
                });
            });

            api
              .get(`/portfolio/investments/${self.value.data.portfolio_item}`)
              .then(data => {
                self.$emit("investment-save", data.data.encrypt.success);
                this.handleCostCheck = false;
                self.$store.dispatch("investment/start", null, { root: true });
                self.saveFiles(self.investmentData);
                if (offeringChanged) {
                  this.$toaster.success("Saved successfully.");
                  this.isShow = false;
                } else {
                  this.saveRound();
                }
                self.updatePortfolioValue(currentCompany._id);
              })
              .catch(err => {
                console.log(err);
                self.isSaving = false;
              });
          })
          .catch(err => {
            self.isSaving = false;
            console.log({ err });
          });
      }
    },
    saveRound() {
      let serverData = JSON.parse(JSON.stringify(this.value.data));
      serverData.roundSize =
        Number(serverData.postMoney) - Number(serverData.preMoney).toFixed(2);
      serverData.source = "User";
      if (this.value.isCreate) {
        if (this.value.portfolio_item) {
          api
            .post(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/${this.value.data.portfolio_item}/valuation`,
              {
                encrypt: {
                  data: serverData
                }
              }
            )
            .then(data => {
              // console.log("data : ", data);
              this.$emit("save-refresh");
              this.handleCancel();
              this.$toaster.success("Saved Successfully.");
              //User Perform action is updated in backend post api
            })
            .catch(error => {
              // console.log("error in inserting valuation data", error);
              this.isSaving = false;
              this.$toaster.error("Failed to Insert !!!");
            });
        }
      } else {
        if (serverData._id) {
          api
            .patch(
              `/${this.$route.params.account_id}/${serverData._id}/valuation`,
              {
                encrypt: {
                  data: serverData
                }
              }
            )
            .then(data => {
              this.$emit("save-refresh");
              this.handleCancel();
              this.$toaster.success("Saved Successfully.");
            })
            .catch(error => {
              // console.log("error in inserting valuation data", error);
              this.$toaster.error("Failed to Update !!!");
            });
        }
      }
    },
    saveFiles(savedDoc) {
      let self = this;
      let filePayload = {
        files: [],
        data: []
      };
      _.forEach(this.files.add, item => {
        if (item) {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "investment",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "File"
          });
        }
      });
      _.forEach(self.url.add, item => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "investment",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "URL",
            url: item
          });
        }
      });

      if (!filePayload.data.length) {
        this.updateFiles(savedDoc);
        return;
      }
      self.$store.dispatch("file/createFile", filePayload).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          }
          self.updateFiles(savedDoc);
        },
        error => {
          this.isSaving = false;
        }
      );
    },

    updateFiles(savedDoc) {
      let self = this;

      self.isSaving = true;

      let filePayload = {
        data: []
      };
      let fileUpdate = [...this.files.update, ...this.url.update];
      _.forEach(fileUpdate, item => {
        if (item._id && self.files.delete.indexOf(item._id) == -1) {
          if (item.link_type == "File") {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "investment",
              document_id: savedDoc._id,
              link_type: "URL"
            });
          } else {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "investment",
              document_id: savedDoc._id,
              link_type: "URL",
              url: item.url
            });
          }
        }
      });

      if (!filePayload.data.length) {
        this.deleteFiles(savedDoc);
        return;
      }

      self.$store.dispatch("file/updateFile", filePayload.data).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          this.deleteFiles(savedDoc);
        },
        error => {
          this.isSaving = false;
        }
      );
    },

    deleteFiles(savedDoc) {
      let self = this;
      let fileDelete = [...this.files.delete, ...this.url.delete];
      if (!fileDelete.length) {
        this.isSaving = false;
        this.value.isShow = false;
        this.url = { add: [], update: [], delete: [] };
        this.files = { add: [], update: [], delete: [] };
        return;
      }

      self.isSaving = true;

      let delCounter = 0;
      _.forEach(fileDelete, async item => {
        if (item) {
          let k = await self.$store.dispatch("file/deleteFile", item._id).then(
            item => {
              delCounter++;
              self.$store.dispatch("file/start", null, { root: true });
            },
            error => {
              delCounter++;
              this.isSaving = false;
            }
          );

          if (delCounter >= fileDelete.length) {
            this.isSaving = false;
            this.url = { add: [], update: [], delete: [] };
            this.files = { add: [], update: [], delete: [] };
            this.value.isShow = false;
          }
        }
      });
    },
    async handleDownload(item, type) {
      if (type == "s3") {
        let self = this;
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path
              }
            }
          })
          .catch(e => {
            console.error("error: ", e);
          });

        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          self.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadAnchor.click();
          });
        }
      }
    },
    handleCost() {
      const self = this;
      let ownerShipCheck = false;
      let callServer = false;
      if (this.value.isCreate) {
        if (
          self.value.data.amount &&
          // self.value.data.amount.length > 0 &&
          isNaN(self.value.data.amount) == false
        ) {
          self.handleCostCheck = true;
          let serverData = {};
          serverData.cost =
            this.currentCompany.cost + Number(self.value.data.amount);
          serverData._id = this.currentCompany._id;
          serverData.__v = this.currentCompany.__v;
          if (
            self.value.data.equity_standing &&
            self.value.data.equity_standing != "" &&
            isNaN(self.value.data.equity_standing) == false
          ) {
            serverData.ownership = this.currentCompany.ownership
              ? this.currentCompany.ownership +
                Number(self.value.data.equity_standing)
              : Number(self.value.data.equity_standing);
            ownerShipCheck = true;
            serverData.ownership =
              serverData.ownership > 100 ? 100 : serverData.ownership;
          }
          if (self.value.data.currentValue != self.currentCompany.value) {
            self.valueCheck = true;
            serverData.value = Number(self.value.data.currentValue);
          }
          if (
            self.investments.length == 0 &&
            (!self.currentCompany.initial_investment ||
              self.currentCompany.initial_investment == "-" ||
              self.currentCompany.initial_investment == "")
          ) {
            serverData.initial_investment = self.value.data.transaction_date
              ? self.value.data.transaction_date
              : new Date();
          }
          let path = "company/apiPatchCompanyInst";
          this.$store.dispatch(path, serverData).then(response => {
            self.$store.dispatch("portfolio/_apiFetchPortfolio").then(data => {
              ownerShipCheck
                ? this.$toaster.success("Cost and Ownership updated")
                : this.$toaster.success("Cost Updated");
              if (self.$parent && self.$parent.tabulator) {
                let data = self.$store.getters["portfolio/portfolioData"];
                self.$parent.tabulator.updateData(data);
              }
              self.valueCheck = false;
              return;
            });
          });
        } else {
          if (
            self.value.data.equity_standing &&
            self.value.data.equity_standing != "" &&
            isNaN(self.value.data.equity_standing) == false
          ) {
            self.handleCostCheck = true;
            let serverData = {};
            serverData._id = this.currentCompany._id;
            serverData.__v = this.currentCompany.__v;
            serverData.ownership = this.currentCompany.ownership
              ? this.currentCompany.ownership +
                Number(self.value.data.equity_standing)
              : Number(self.value.data.equity_standing);
            ownerShipCheck = true;
            serverData.ownership =
              serverData.ownership > 100 ? 100 : serverData.ownership;
            if (self.value.data.currentValue != self.currentCompany.value) {
              self.valueCheck = true;
              serverData.value = Number(self.value.data.currentValue);
            }
            if (
              self.investments.length == 0 &&
              (!self.currentCompany.initial_investment ||
                self.currentCompany.initial_investment == "-" ||
                self.currentCompany.initial_investment == "")
            ) {
              serverData.initial_investment = self.value.data.transaction_date
                ? self.value.data.transaction_date
                : new Date();
            }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  this.$toaster.success("Ownership updated");
                  if (self.$parent && self.$parent.tabulator) {
                    let data = self.$store.getters["portfolio/portfolioData"];
                    self.$parent.tabulator.updateData(data);
                  }
                  self.valueCheck = false;
                  return;
                });
            });
          } else {
            if (
              !self.currentCompany.initial_investment ||
              self.currentCompany.initial_investment == "-" ||
              self.currentCompany.initial_investment == ""
            ) {
              if (self.investments && self.investments.length > 1) {
                return;
              }
              self.handleCostCheck = true;
              let serverData = {};
              serverData._id = this.currentCompany._id;
              serverData.__v = this.currentCompany.__v;
              serverData.initial_investment = self.value.data.transaction_date
                ? self.value.data.transaction_date
                : new Date();
              if (self.value.data.currentValue != self.currentCompany.value) {
                self.valueCheck = true;
                serverData.value = Number(self.value.data.currentValue);
              }
              let path = "company/apiPatchCompanyInst";
              this.$store.dispatch(path, serverData).then(response => {
                self.$store
                  .dispatch("portfolio/_apiFetchPortfolio")
                  .then(data => {
                    if (self.$parent && self.$parent.tabulator) {
                      let data = self.$store.getters["portfolio/portfolioData"];
                      self.$parent.tabulator.updateData(data);
                    }
                    self.valueCheck = false;
                    return;
                  });
              });
            }
          }
        }
      } else {
        // if (
        //   self.value.data.amount &&
        //   self.value.data.amount.length > 0 &&
        //   isNaN(self.value.data.amount) == false
        // ) {
        let serverData = {};
        let presentAmount =
          self.value.data.amount &&
          // self.value.data.amount.length > 0 &&
          isNaN(self.value.data.amount) == false
            ? Number(self.value.data.amount)
            : 0;
        let previousAmount =
          self.investmentData.amount &&
          // && self.investmentData.amount.length > 0
          !isNaN(self.value.data.amount)
            ? Number(self.investmentData.amount)
            : 0;
        let finalCost = 0;
        if (presentAmount != previousAmount) {
          callServer = true;
          if (presentAmount > previousAmount) {
            finalCost = presentAmount - previousAmount;
            serverData.cost = this.currentCompany.cost + finalCost;
          } else {
            finalCost = previousAmount - presentAmount;
            serverData.cost =
              this.currentCompany.cost > 0
                ? this.currentCompany.cost - finalCost
                : 0;
          }
          serverData.cost = serverData.cost > 0 ? serverData.cost : 0;
        }
        serverData._id = this.currentCompany._id;
        serverData.__v = this.currentCompany.__v;
        let finalOwnership = 0;
        let presentEquityStanding =
          self.value.data.equity_standing &&
          self.value.data.equity_standing != "" &&
          self.value.data.equity_standing.length > 0 &&
          isNaN(self.value.data.equity_standing) == false
            ? Number(self.value.data.equity_standing)
            : 0;
        presentEquityStanding =
          presentEquityStanding > 100 ? 100 : presentEquityStanding;
        let previousEquityStanding =
          self.investmentData.equity_standing &&
          self.investmentData.equity_standing.value &&
          self.investmentData.equity_standing.value != "" &&
          self.investmentData.equity_standing.value.length > 0 &&
          isNaN(self.investmentData.equity_standing.value) == false
            ? Number(self.investmentData.equity_standing.value)
            : 0;
        previousEquityStanding =
          previousEquityStanding > 100 ? 100 : previousEquityStanding;
        if (presentEquityStanding != previousEquityStanding) {
          callServer = true;
          if (presentEquityStanding > previousEquityStanding) {
            finalOwnership = Number(
              (presentEquityStanding - previousEquityStanding).toFixed(1)
            );
            finalOwnership = finalOwnership > 100 ? 100 : finalOwnership;
            finalOwnership = finalOwnership < 0 ? 0 : finalOwnership;
            serverData.ownership = this.currentCompany.ownership
              ? Number(
                  (this.currentCompany.ownership + finalOwnership).toFixed(1)
                )
              : Number(finalOwnership.toFixed(1));
          } else {
            finalOwnership = Number(
              (previousEquityStanding - presentEquityStanding).toFixed(1)
            );
            serverData.ownership =
              this.currentCompany.ownership > 0
                ? Number(
                    (this.currentCompany.ownership - finalOwnership).toFixed(1)
                  )
                : 0;
          }
          serverData.ownership =
            serverData.ownership > 100 ? 100 : serverData.ownership;
          serverData.ownership =
            serverData.ownership > 0 ? serverData.ownership : 0;
        }
        if (self.value.data.currentValue != self.currentCompany.value) {
          self.valueCheck = true;
          serverData.value = Number(self.value.data.currentValue);
        }
        let index = self.investments.findIndex(item => {
          return item._id == self.value.data._id;
        });
        if (self.investments.length == 1 || index == 0) {
          serverData.initial_investment = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
        }
        if (callServer) {
          let path = "company/apiPatchCompanyInst";
          this.$store.dispatch(path, serverData).then(response => {
            self.$store.dispatch("portfolio/_apiFetchPortfolio").then(data => {
              // ownerShipCheck
              //   ? this.$toaster.success("Cost and Ownership updated")
              //   : this.$toaster.success("Cost Updated");
              self.valueCheck = false;
              return;
            });
          });
        }
      }
    },
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || this.value.data.price_per_share.indexOf(".") != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        this.value.data.price_per_share != null &&
        this.value.data.price_per_share.indexOf(".") > -1 &&
        this.value.data.price_per_share.split(".")[1].length > 1
      ) {
        $event.preventDefault();
      }
    },

    isIPOAcquisitionStatus() {
      return (
        this.currentCompany &&
        (this.currentCompany.status === "IPO" ||
          this.currentCompany.status === "Acquired")
      );
    },

    handleCancelContact() {
      let self = this;

      if (self.isSavingClicked) {
        self.isSavingClicked = false;
        return;
      }

      self.showFounderEmailConfirm = false;
      self.saveInvestment();
      return;
    },
    saveContactEmail() {
      let self = this;

      if (self.isCorrectCompanyEmail == "Yes") {
        self.isSavingClicked = true;
        self.showFounderEmailConfirm = false;
        self.saveInvestment(false);
        return;
      }

      if (!this.checkIfValidEmail()) {
        return;
      }

      self.savingContact = true;

      self.contactEmail = self.newContactEmail;

      self.isSavingClicked = true;

      api
        .patch(
          `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/company`,
          {
            encrypt: {
              data: {
                _id: self.currentCompany._id,
                contact_email: self.newContactEmail
              }
            }
          }
        )
        .then(resp => {
          self.$store.dispatch("portfolio/_apiFetchPortfolio");
          self.$toaster.success("Updated contact email!");
          self.savingContact = false;
          self.showFounderEmailConfirm = false;
          self.saveInvestment(false);
        })
        .catch(err => {
          console.log("edit company error", error);
          self.$toaster.error("Failed to update contact email!");
          self.savingContact = false;
          self.isSavingClicked = false;
        });
    },
    updatePortfolioValue(id){
      api.patch(`/updatePortfolioValue/${id}`).then((res)=>{
        // console.log("data : ", res);
      }).catch(err => {
        console.error("error updating portfolio value : ", err);
      })
    }
  }
};
</script>
<style>
.tags-input span {
  margin-left: 0px;
  margin-bottom: 2px;
}
.tags-input-remove:before,
.tags-input-remove:after {
  content: "";
  position: absolute;
  width: 75%;
  font-size: 12px;
  left: 0.15em;
  background: #b5b5b5;
  height: 2px;
  margin-top: -2px !important;
}
.tags-input-badge {
  font-size: 13px !important;
  font-weight: lighter !important;
  height: 21px;
}
.b-form-tag {
  background: #ededed 0% 0% no-repeat padding-box;
  border-radius: 13px;
  color: black;
  height: 21px;
  font-size: 13px;
}
.tags-input-wrapper-default {
  padding: 0.5em 1em !important;
}

textarea {
  word-break: break-word;
}

.email-preview {
  width: 100%;
  text-align: left;
  padding: 0 30px;
  color: #00000080;
}

.email-preview p {
  margin: 18px 0;
  word-break: keep-all;
}

.email-preview button {
  display: block;
  width: 310px;
  padding: 10px;
  outline: none;
  border: none;
  border-radius: 3px;
  background: #78de87;
  margin: auto;
  cursor: default;
  font-size: 16px;
}

.email-preview-header {
  display: grid;
  place-items: center;
  width: 100%;
  height: 75px;
  background: #5445f3;
  opacity: 1;
  font-family: Comfortaa, cursive;
  font-size: 30px;
  text-transform: none;
  color: #fff;
}

.accordian {
  color: #303133;
}

.accordian button {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  background: none;
  outline: none;
  border: none;
  padding: 8px 0;
}

.accordian button:hover {
  background: none;
}

.accordian button p {
  margin: 0;
  color: #303133;
  line-height: 24px;
  font-size: 18px;
}

.accordian button i {
  color: #303133;
  transition: all 0.3s ease;
}

.accordian button[aria-expanded="true"] i {
  transform: rotate(180deg);
}

.no_word_break{
  word-break: keep-all;
}

</style>
